export default __webpack_public_path__ + "assets/images/icons/bitbucket.1b09e088.svg";